import { SPOTIM } from 'types/global/spotim';

import { watchForSpotimObject } from './watchForSpotimObject';

let spotim: SPOTIM;
let spotimPromise: Promise<SPOTIM>;

type Args = {
  spotId: string;
};

// Reference https://github.com/SpotIM/spotim-integration-docs/blob/master/api/single-sign-on/spa.js
export async function loadOpenWebScriptOnce({ spotId }: Args): Promise<SPOTIM> {
  if (spotim) return spotim;
  if (spotimPromise) return spotimPromise;

  const meta = document.createElement('meta');
  meta.name = 'spotim-ads';
  meta.content = 'disable-all';
  document.head.appendChild(meta);

  const script = document.createElement('script');
  script.src = `https://launcher.spot.im/spot/${spotId}`;
  script.async = true;
  script.dataset.spotimModule = 'spotim-launcher';
  script.dataset.spotimAutorun = 'false';
  document.head.appendChild(script);

  spotimPromise = watchForSpotimObject();
  spotim = await spotimPromise;

  return spotim;
}
